<div class="custom-row">
    @if(mode==="read" && leadStatus !== approvedStatus && !(entry === 'referral' && (leadStatus === 'Review Complete' || leadStatus === deniedStatus)) && !readOnly && showEdit){
      <ppl-button
      label="Edit" 
      icon="fa fa-pencil" 
      [customClass]="'ghost-button'" 
      [iconPosition]="'left'"
      (click)="doMfa()"
      *authorize="[pageId, tabId, 'AddressInformation', 'section', 'edit']"
      ></ppl-button>      
    <!-- <span
      (click)="editInfo()"
      nz-icon
      nzType="edit"
      nzTheme="outline"
      *authorize="[pageId, tabId, 'AddressInformation', 'section', 'edit']"
    ></span> -->
    }
  </div>

@if(mode==="edit"){

    <div class="ppl-mt24">
        <form nz-form [formGroup]="contactForm" class="ppl-p0">
          @if(isAttrAvailable('permanentAddress')){
          <nz-form-item nzSpan="24" nz-col class="ppl-form-item">
            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="permanentAddress"
              class="ppl-form-label">{{getAttributes('permanentAddress').label}}
              @if(getAttributes('permanentAddress').mandatory === 'Y'){
              <span [attr.aria-label]="'Required'">*</span>
              }
            </nz-form-label>
            <div class="address-section">
              <nz-form-control class="ppl-form-control address-control">
                <ppl-lead-details-address [addressForm]="getFormGroup('permanentAddress')" [is_permanent]="true" [statesList]="statesList" [validationErrors]="validationErrorsPermanentAdd" [isCountyRequired]="getAttributes('countyOrRegion').mandatory === 'Y'"></ppl-lead-details-address>
              </nz-form-control>
            </div>
          </nz-form-item>
          <nz-divider class="divider"></nz-divider>
          }
          @if(!contactForm.get('permanentAddress')?.value.mailing){
            @if(isAttrAvailable('mailingAddress')){
              <nz-form-item nzSpan="24" nz-col class="ppl-form-item">
                <div class="address-section">
                  <nz-form-control class="ppl-form-control address-control">
                    <ppl-lead-details-address [addressForm]="getFormGroup('mailingAddress')" [is_permanent]="false" [statesList]="statesList" [validationErrors]="validationErrorsMailingAdd" [isCountyRequired]="getAttributes('countyOrRegion').mandatory === 'Y'"></ppl-lead-details-address>
                  </nz-form-control>
                </div>
              </nz-form-item>
              
            }
          }
          @if(isAttrAvailable('residentGt18')){
            <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="residentGt18" class="ppl-form-label" >{{ getAttributes("residentGt18").label }}
                @if(getAttributes('residentGt18').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }</nz-form-label>
              <nz-form-control class="ppl-form-control" nz-tooltip nzTooltipTitle="{{getAttributes('residentGt18').tooltip}}"
                nzTooltipPlacement="topRight">
                <div [ngClass]="{'error': validationErrors['residentGt18'] }">
                  <ppl-dropdown-select formControlName="residentGt18" id="residentGt18"
                    [options]="radioOptions" [optionLabel]="'label'" [optionValue]="'value'">
                  </ppl-dropdown-select>
                </div>
                @if (validationErrors['residentGt18']) {
                <span class="pl-1 error-message">{{validationErrors['residentGt18']}}</span>
                }
              </nz-form-control>
            </nz-row>
            </nz-form-item>
            }
        </form>
    </div>
    <div class="custom-row">
      <ppl-button 
      label="Cancel" 
      icon="fa fa-ban" 
      [customClass]="'alt-button'" 
      [iconPosition]="'left'"
      (click)="cancelEdit()"
      ></ppl-button>    
  
      <ppl-button 
      label="Save" 
      icon="fa fa-floppy-o" 
      [customClass]="'alt-button'" 
      [iconPosition]="'left'"
      (click)="save()"
      ></ppl-button>
    </div>
    }
    @else if(mode==="read" && filledInfo?.permanentAddress && secData){
      <div tabindex="0">
    
    @if(isAttrAvailable('permanentAddress')){
    <div nz-row>
      <div nz-col nzSpan="8" [nzXs]="24" class="ppl-read-label">{{getAttributes('permanentAddress').label}} :</div>
    </div>
    
    <ppl-lead-details-address [mode]="'read'" [data]="filledInfo.permanentAddress" [statesList]="statesList"></ppl-lead-details-address>
   
    }@else {
      <nz-row>
        <p tabindex="0">No Data found</p>
      </nz-row>
    }
    
    @if(isAttrAvailable('mailingAddress')){
      @if(!filledInfo.permanentAddress?.mailing){
        <div nz-row class="pb-2 pt-2">
          <div nz-col nzSpan="12" [nzXs]="24" class="ppl-read-label">{{getAttributes('mailingAddress').label}} :</div>
        </div>

        <ppl-lead-details-address [mode]="'read'" [is_permanent]="false" [data]="filledInfo.mailingAddress" [statesList]="statesList"></ppl-lead-details-address>
      
        }
    }

        
    @if(isAttrAvailable('mcoAddress') && filledInfo.mcoAddress){
      <nz-divider class="divider"></nz-divider>
        <div nz-row class="pb-2 pt-2">
          <div nz-col nzSpan="12" [nzXs]="24" class="ppl-read-label">{{getAttributes('mcoAddress').label}} :</div>
        </div>

        <ppl-lead-details-address [mode]="'read'" [is_permanent]="false" [data]="filledInfo.mcoAddress" [statesList]="statesList"></ppl-lead-details-address>
    }
    @if(isAttrAvailable('residentGt18')){
      <div nz-row>
        <div nz-col [nzXs]="24" [nzSm]="16" [nzMd]="16" [nzLg]="10" [nzXXl]="4" class="ppl-read-label">{{getAttributes('residentGt18').label}}</div>
        <div nz-col >{{ filledInfo['residentGt18'] }}</div>
      </div>
      }
    </div>
    }@else if(mode==="read" && !filledInfo?.permanentAddress ){
        <nz-row>
            <p tabindex="0">No Data found</p>
          </nz-row>
    }
